import Client from "./client";

export default class Resources {
    constructor(env) {
        this.client = new Client(env)
    }

    list() {

    }

    async read(request) {
        const { data } = await this.client.http().post("/v3/system/thunder", request)

        return data
    }

    async write(request) {
        const { data } = await this.client.http().put("/v3/system/thunder", request)

        return data
    }
}